// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"16d5141c","488":"142ae9c3"}[chunkId] + ".chunk.js";
};